import React, { useEffect, useState } from 'react';
import Input from '../../ui/input';
import Label from '../../ui/label';
import Textarea from '../../ui/textarea';
import { validateZone } from '../../../model/ZoneModel'; // Import your Yup validation schema
import { zoneUpdate } from '../../../redux/api/zoneAPI'; // Import the function responsible for updating zone data
import ButtonLoadingSpinner from '../../loader/ButtonLoadingSpinner';
import Select from '../../ui/select';
import { getSites, siteLayoutGet } from '../../../redux/api/siteAPI';
import Button from '../../ui/button';
import { useTranslation } from 'react-i18next';
import SitePolygonEditor from '../../site/SitePolygonEditor';
const sites = [
    {
        Site_ID: 1,
        Name: "yard 1"
    },
    {
        Site_ID: 2,
        Name: "Room 2"
    },
    {
        Site_ID: 3,
        Name: "Hallway 1"
    },
]
const EditZoneModal = ({ data, isOpen, onClose }) => {
    const {t }= useTranslation('common');
    const [formData, setFormData] = useState(data);
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [error, setError] = useState(null);
    const [sitesList, setSitesList] = useState([]);
    const [siteLayout, setSiteLayout] = useState(null);
    // const [site, setSite] = useState({});
    console.log(formData)

    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                const sitesRes = await getSites();
                setSitesList(sitesRes.data.sites);
                // setSite(sitesRes.find(site => site.Site_ID === formData.Site))

            } catch (err) {
                // setError(err);
                // static
                setSitesList(sites);
            } finally {
                setLoading(false);
            }
        };
        fetchInitialData();
    }, []);
    useEffect(() => {
        setFormData({
            ...data,
            Fill_color: data.Fill_color || '#f97316',
        })
    }, [data])
    useEffect(() => {
        const fetchLayout = async () => {
            if (!formData?.Site_ID) {
                setSiteLayout(null);
                return;
            }
            const { data } = await siteLayoutGet(formData.Site_ID);
            setSiteLayout(data);
        };
        fetchLayout();
    }, [formData?.Site_ID]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        // Clear error message when user starts typing
        if (formErrors[name]) {
            setFormErrors(prevErrors => ({
                ...prevErrors,
                [name]: ''
            }));
        }
    };

    const closeModal = (refresh) => {
        onClose(refresh);
    };

    const validateForm = async () => {
        try {
            await validateZone(formData);
            return true; // Form is valid
        } catch (error) {
            const validationErrors = {};
            error.inner.forEach(err => {
                validationErrors[err.path] = err.message;
            });
            setFormErrors(validationErrors);
            return false; // Form is invalid
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = await validateForm();
        if (isValid) {
            let timeout;
            try {
                setLoading(true);
                setLoadingText("Updating Site...");
                timeout = setTimeout(() => {
                    setLoadingText("This is taking longer than usual. Please wait.");
                }, 5000);
                // If validation successful, proceed with form submission
                const result = await zoneUpdate(formData); // Call the zoneUpdate function with the form data
                if (result.data)
                    closeModal(true); // Close modal or perform other actions
                else
                    setError(result.error)
                setLoading(false);
                clearTimeout(timeout);
            } catch (error) {
                console.error("Error updating zone:", error); // Log any errors
                setError("An unexpected error occurred while updating the zone.");
                setLoading(false);
                clearTimeout(timeout);
            }
        }
    };

    return (
        <form data-testid="zone-edit-form" onSubmit={handleSubmit}>
            <div className="grid space-x-6 gap-7 max-lg:grid-cols-1 grid-cols-2 w-auto m-2 bg-white max-md:p-3 p-8 rounded-3xl shadow-lg">
                <p className="flex justify-center col-span-2 text-xl text-[#4C4C66] font-bold mb-4">{t('edit_zone_details')}</p>
                {/* form */}
                <Input
                    required
                    label={t('zone_name')}
                    name="Zone_name"
                    value={formData.Zone_name}
                    onChange={handleChange}
                    placeholder={t('enter_zone_name')}
                    error={formErrors.Zone_name}
                />

                <Select
                    inputId="e2e-zone-edit-risk"
                    selectOnly
                    required
                    isSearchable={false}
                    label={t('risk_level')}
                    name="Risk_level"
                    options={[
                        { label: t("high"), value: "High" },
                        { label: t("medium"), value: "Medium" },
                        { label: t("low"), value: "Low" },
                    ]}
                    value={{
                        value: formData.Risk_level,
                        label: formData.Risk_level
                    }}
                    // className='shrink w-full rounded-xl p-2 bg-[#F4F6FA]'
                    onChange={(option) => setFormData(prevState => ({ ...prevState, Risk_level: option.value }))}
                    placeholder={t('select_risk_level')}
                    error={formErrors.Risk_level}
                />

                <Select
                    required
                    label={t('site')}
                    name="Site_ID"
                    options={sitesList.map(site => ({ label: site.Name, value: site.Site_ID }))}
                    value={{
                        value: formData.Site_ID,
                        label: formData.site.Name
                    }}
                    // className='shrink w-full rounded-xl p-2 bg-[#F4F6FA]'
                    onChange={(option) => setFormData(prevState => ({ ...prevState, Site_ID: option.value }))}
                    placeholder={t('select_site')}
                    error={formErrors.Site_ID}
                />
                <div className='col-span-full '>

                    <Textarea
                        required
                        label={t('description')}
                        name="Zone_description"
                        maxLength={200}
                        value={formData.Zone_description}
                        onChange={handleChange}
                        rows={5}
                        placeholder={t('enter_zone_description')}
                        error={formErrors.Zone_description}
                    />
                </div>
                {formData.Site_ID && (
                    <SitePolygonEditor
                        layout={siteLayout}
                        value={formData.Polygon_json}
                        fillColor={formData.Fill_color || '#f97316'}
                        zoneId={formData.Zone_ID}
                        onChange={(polygonJson) => setFormData(prevState => ({ ...prevState, Polygon_json: polygonJson }))}
                        onFillColorChange={(color) => setFormData(prevState => ({ ...prevState, Fill_color: color }))}
                    />
                )}
                {error && (
                    <div className="col-span-full flex justify-center space-x-5">
                        <span className="my-4 ml-2 text-xs text-[#FF0000]">{t('error_updating_site')}</span>
                    </div>
                )}
                <div className='col-span-2 flex justify-center mt-10 space-x-5'>
                    <Button
                        onClick={()=>closeModal(false)}
                        color={"cancel"}
                        className="md:w-[200px] w-auto bg-[#ffffff] border text-[#4C4C66] px-4 py-2 rounded-2xl"
                    >{t('cancel')}</Button>
                    <Button
                        data-testid="zone-edit-submit"
                        disabled={loading}
                        type="submit"
                        className="md:w-[200px] w-auto bg-[#0071BC] text-white px-4 py-2 rounded-2xl"
                    >{t('update_zone')}</Button>
                </div>
            </div>
        </form>
    );
};

export default EditZoneModal;
